<template>
  <div>
    <v-card class="ma-2">
      <v-card-title  class="teal white--text">
        Parameter Aplikasi
        <v-spacer />
        <!-- <v-btn  @click.stop="dlgParam = true">
          <v-icon left>add</v-icon>
          Tambah
        </v-btn> -->
      </v-card-title>
      <v-card-text>
        <v-container class="">          
          <v-row class="green accent-2 px-2">  
            <v-col cols="4">
              <p class="subtitle-2">                      
                Nama
              </p>
            </v-col>                
            <v-col cols="4">
              <p class="subtitle-2">                      
                Value
              </p>
            </v-col>
            
            <v-col cols="2">
              <p class="subtitle-2">                      
                -
              </p>
            </v-col>
          </v-row>
          <v-divider />
          <template v-if="pos3Count == 0">
            <v-row >
              <v-col cols="12" class="text-center">
                <p>TIDAK ADA DATA</p>
              </v-col>
            </v-row>
          </template>
          <template v-else>
            <template v-for="item in pos3List">
              <v-row :key="item.id" class="px-2">
                <v-col cols="4" >                   
                    <div>
                    {{ item.key }}
                    </div>
                </v-col>
                <v-col cols="4">
                  <div>{{ item.value }}</div>
                </v-col>
                <v-col cols="2">
                  <span> 
                    <v-btn icon color="blue" @click="editParam(item.id)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </span>
                </v-col>
              </v-row>
              <v-divider :key="'A'+item.id"/>
            </template>
          </template>
        </v-container>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dlgParam" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Ubah Parameter</span>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="form3"
            v-model="valid"
            lazy-validation
          >
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    label="Nama"
                    name="nomor"
                    type="text"
                    outlined
                    :rules=[]
                    v-model="key"
                  />     
                </v-col>
                <v-col cols="6">               
                  <v-text-field
                    label="Value"
                    type="text"
                    outlined                    
                    :rules=[]
                    v-model="value"
                  />  
                </v-col>
              </v-row>              
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="success" dark @click="dlgParamClick">Simpan</v-btn>
          <v-btn color="orange" dark @click="dlgParam = false">Batal</v-btn>
          <v-btn color="info" dark @click="resetForm3">Reset</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="submitting" persistent max-width="300px">
        <v-card dark>
            <v-card-title>Sedang diproses</v-card-title>
            <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
        </v-card>
    </v-dialog>

  </div>
</template>

<script>
const apiUrl = process.env.VUE_APP_ROOT_API
import axios from 'axios'

export default {
  data: function() {
    return {
      //
      id: -999,
      key: '',
      value: '',
      dlgParam: false,
      pos3Count: 3,
      pos3List: [],
      valid: true,

      submitting: false,
    }
  },
  methods: {
    resetForm3: function() {
      this.$refs.form3.reset() 
    },
    editParam: function(id) {
      this.id = id
      this.key = this.pos3List.find(el => el.id === id).key
      this.value = this.pos3List.find(el => el.id === id).value
      this.dlgParam = true
    },
    dlgParamClick: async function() {
      const message = {
        id: this.id,
        key: this.key,
        value: this.value,
      }
      this.$store.dispatch('displayProgBar');
      this.submitting = true;

      await axios.post(apiUrl+'/admin/param', message)
      .then((response) => {
        console.log(response)
        this.$store.dispatch('displayAlert', {
          color: 'success', 
          message: `Data parameter sudah diupdate !` })
        window.scroll(0,0)        

        console.log(`Key: ${message.key}, Value: ${this.$store.getters[message.key]}`);
        this.$store.commit("setRules", message);
        console.log(`Key: ${message.key}, Value: ${this.$store.getters[message.key]}`);

        const obj = this.pos3List.find(el => el.id === this.id)
        obj.value = this.value
        this.dlgParam = false
      })
      .catch((err) => {
        this.$store.dispatch('displayAlert', {color: 'error', message: err})
        window.scroll(0,0)
      })
      .finally(() => {
        this.$store.dispatch('closeProgBar');
        this.submitting = false;
      })        
    }
  },
  created: async function() {
    await axios.get(apiUrl+'/admin/param')
    .then((response) => {
      if (response.data.statusCode != 200) {
        this.pos3List = []
      }
      else {
        response.data.data.rows.forEach(element => {          
          this.pos3List.push(element)
        })              
      }
      this.pos3Count = this.pos3List.length
    })
    .catch((error) => {
      console.log(error)
    })  
  }
}
</script>

<style>

</style>